import axios from 'axios';

const apiWithAuth = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

let getAccessToken: (() => Promise<string>) | null = null;

export const setTokenGetter = (getter: () => Promise<string>) => {
  getAccessToken = getter;
};

apiWithAuth.interceptors.request.use(async (config) => {
  // Use JWT token from sessionStorage (set by AuthContext)
  const jwtToken = sessionStorage.getItem('jwt_token');
  
  if (jwtToken) {
    config.headers.Authorization = `Bearer ${jwtToken}`;
  } else if (getAccessToken) {
    // Fallback to Auth0 token if JWT not available
    try {
      const token = await getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error getting access token:', error);
    }
  }
  return config;
});

export default apiWithAuth;
